export default __webpack_public_path__ + "static/media/2_Blop.13a347b7.wav";